$(document).ready(function(){
    $('.bttn__language').click(function() {
       $('.language-selector').fadeToggle();
    });
});
